<template>
  <div id="report-detail">
    <ipub-model width="1000px"
                :showHeader="true"
                :title="`Review Details`"
                style="min-width:450px;overflow:hidden"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div>
        <div class="relative"
             v-if="responseData && responseData.length>0">
          <div class="ipub-p1 ipub-list-tab mar-b-20">
            <a v-for="(item,index) in responseData.slice(0,3)"
               :key="item.id+index"
               @click="changeReport(item)"
               :class="['','ipub-list-tab--status',item.sign==activeKey ? 'active':'']">
              {{termListStatus[item.decisionStatus]}} (Report{{item.sign}})
            </a>
          </div>
          <div class="right-option ipub-p1 ipub-c-p"
               @click="showTabMore=!showTabMore"
               v-if="responseData.length>3">
            <div style="text-align:right"
                 class="mar-b-10">View More
              <ipub-icon :class="['ipub-p5 mar-l-10 rotate',showTabMore?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <template v-if="showTabMore">
              <div class="ipub-list-tab-more">
                <div :class="['ipub-list-tab-more-item',item.sign==activeKey ? 'active':'']"
                     @click="changeReport(item)"
                     v-for="(item,index) in responseData.slice(3)"
                     :key="item.id+index">{{termListStatus[item.decisionStatus]}} (Report{{item.sign}})</div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="activeData">
          <div class="mar-b-20">
            <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer ipub-title-tab"
                 @click="togalEditor(activeData,'showQuestion')">
              Custom Review Questions
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showQuestion?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div class="question-answer"
                 v-if="!activeData.showQuestion">
              <customerReviewQuestion :questionList="activeData.questionList"></customerReviewQuestion>
            </div>
          </div>
          <div class="mar-b-20">
            <div class="ipub-h3 line-h-40 mar-b-12 ipub-title-tab"
                 @click="togalEditor(activeData,'showAuthor')">
              Comments to Author
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAuthor?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div v-if="!activeData.showAuthor">
              <div class="ipub-p2"
                   v-if="activeData.authorNotes"
                   v-html="activeData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>

            </div>

          </div>
          <div class="mar-b-20">
            <div class="ipub-h3 line-h-40 fw-bd mar-b-12 ipub-title-tab"
                 @click="togalEditor(activeData,'showEditor')">
              Comments to Editor
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showEditor?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div v-if="!activeData.showEditor">
              <div class="ipub-p2"
                   v-if="activeData.editorNotes"
                   v-html="activeData.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>
            </div>

          </div>

          <div class="mar-b-20"
               v-show="activeData.reviewerFileList && activeData.reviewerFileList.length>0">
            <div class="ipub-h3 line-h-40 mar-b-16 ipub-title-tab"
                 @click="togalEditor(activeData,'showAttachment')">Attachment of Reviewer
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAttachment?'':'rotate-180']"
                         type="iconArrow" />
            </div>

            <div class="file-contain"
                 v-if="!activeData.showAttachment">
              <ipub-label size="small"
                          hover
                          class="ipub-p2"
                          style="align-items: center;height:30px;margin-right:8px;margin-bottom: 12px"
                          v-for="(itemfile,indexfile) in activeData.reviewerFileList"
                          :key="itemfile.id"
                          @click="download(itemfile,indexfile)">
                {{itemfile.name}}
                <ipub-icon type="iconDownload1"
                           class="mar-l-10"></ipub-icon>
              </ipub-label>
            </div>
          </div>

          <div>
            <a :name="'toReport'">
              <div class="ipub-p2 fw-bd line-h-40 mar-b-12 ipub-title-tab"
                   @click="togalEditor(activeData,'showAuthorReplay')"
                   v-if="activeData.authorReply || (activeData.authorReplyFileList && activeData.authorReplyFileList.length>0)">
                Author’s Response
                <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAuthorReplay?'':'rotate-180']"
                           type="iconArrow" />
              </div>
              <div v-if="!activeData.showAuthorReplay">
                <div v-show="activeData.authorReply">
                  <div class="ipub-p1 mar-b-12">
                    Author’s Note
                  </div>
                  <div class="ipub-p2"
                       v-html="activeData.authorReply?activeData.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
                </div>
                <div style="margin-top:20px"
                     v-show="activeData.authorReplyFileList && activeData.authorReplyFileList.length>0">
                  <div class="ipub-p1 mar-b-10">
                    Author’s Response File
                  </div>
                  <ipub-label hover
                              class="ipub-p2"
                              style="margin-right:8px;margin-bottom: 12px"
                              v-for="(itemauth,indexauth) in activeData.authorReplyFileList"
                              :key="itemauth.id"
                              @click="download(itemauth,indexauth)">
                    {{itemauth.name}}
                    <ipub-icon type="iconDownload1"
                               class="mar-l-10"></ipub-icon>
                  </ipub-label>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DECISION_STATUS } from '@/utils/dict'
import help from '@/utils/help'
import zip from '@/utils/zip'
import customerReviewQuestion from '@/components/question.vue'
import { reviewerInvite } from '@/api/reviewer'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    customerReviewQuestion
  },
  data () {
    return {
      termListStatus: DECISION_STATUS,
      activeKey: '',
      activeData: {},
      responseData: {},
      showTabMore: false

    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable (newV) {
      if (newV) {
        this.getData()
      }
    }
  },
  mounted () {
  },
  methods: {
    changeReport (item) {
      this.activeKey = item.sign
      this.activeData = item
    },
    download (item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    async getData () {
      const result = await reviewerInvite.report(this.inputData.id)
      this.responseData = result
      this.activeData = this.responseData && this.responseData[0]
      this.activeKey = this.activeData && this.activeData.sign
    },

    // comments to Editor Author
    togalEditor (item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.activeData = JSON.parse(JSON.stringify(this.activeData))
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';
</style>